export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A. een enkele partner',
  'privacy-policy': 'Privacybeleid',
}
